export default __webpack_public_path__ + "static/media/cancelled.f1480b90.svg";